// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-name[data-v-3b399078]{width:288px}", "",{"version":3,"sources":["webpack://./src/client/features/instagram_post/instagram_post_filter/InstagramPostFilter.vue"],"names":[],"mappings":"AAGA,+BACE,WAAA","sourcesContent":["\n@use '@/client/assets/scss/variables.scss' as *;\n\n.account-name {\n  width: $spacing-unit * 36;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
